import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from './authAPI';

const initialState = {
  token: localStorage.getItem('token') || null, // Check localStorage for a token
  user: null,
  status: 'idle', // idle, loading, succeeded, failed
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem('token'); // Remove token from localStorage on logout
      localStorage.removeItem('user');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        console.log(action.payload)
        state.status = 'succeeded';
        state.token = action.payload.token;
        state.user = action.payload.user;
        localStorage.setItem('token', action.payload.token); // Save token to localStorage
        localStorage.setItem('user', action.payload.userId); 
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
